class GallerySK {
	constructor(parent) {
		this._init()
	}
	_init() {
        this.root = document.querySelector('[data-gallery-sk]')

        if (!this.root) {
            return
        }

        this.dst = this.root.querySelector('[data-gallery-sk-dst]')

        this.root.querySelectorAll('[data-gallery-sk-src]').forEach(el => {
            el.addEventListener('click', () => {
                this.hideDst()
                setTimeout(() => {
                    const src = el.querySelector('img[data-size-w1920]').dataset.sizeW1920
                    const img = new Image();
                    img.onload = () => {
                        this.dst.style.backgroundImage = 'url(' + src + ')'
                        this.showDst()
                    }
                    img.src = src;
                }, 400)
            })
        })
	}
    hideDst() {
        this.dst.style.opacity = "0"
        this.dst.style.transition = "opacity 0.3s"
    }
    showDst() {
        this.dst.style.opacity = "1"
    }
}

export default GallerySK
